import ReglementsInsertForm from "../../components/Reglements/ReglementsInsertForm";



function ReglementsAdd(){


    return (
        <ReglementsInsertForm   ></ReglementsInsertForm>
    );
}
export default ReglementsAdd;